module.exports = __webpack_public_path__ + "static/img_23-677bd2880e135096dde85ccfde2a494b.png";